"use client";
import { FormControl, FormHelperText, Stack, TextField } from "@mui/material";
import { useTranslations } from "next-intl";
import { useState } from "react";
const TextFieldComponent = ({
  error,
  success,
  errorMessage,
  endAdornment,
  startAdornment,
  textFieldStyle,
  inputPropsStyle,
  maxLength = 120,
  formControlStyle,
  allowCapitalization = false,
  shrink,
  type = "text",
  countRequired = false,
  onBlur,
  onChange,
  multiline = true,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const t = useTranslations("Validations");

  const handleBlur = (e) => {
    setIsFocused(false);
    if (e.target.value && typeof e.target.value === "string") {
      const trimmedValue = e.target.value.trim();
      if (trimmedValue !== e.target.value && onChange) {
        e.target.value = trimmedValue;
        onChange(e);
      }
    }
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <FormControl fullWidth sx={{ ...formControlStyle }}>
      <TextField
        autoComplete="off"
        onFocus={() => setIsFocused(true)}
        onBlur={handleBlur}
        onChange={onChange}
        disabled={props?.disabled}
        InputLabelProps={{
          shrink,
          style: {
            pointerEvents: props?.disabled ? "none" : "auto",
          },
        }}
        multiline={multiline}
        maxRows={multiline ? 6 : undefined}
        variant="outlined"
        error={Boolean(error)}
        color={success ? "success" : ""}
        sx={{
          pointerEvents: props?.disabled ? "none" : "auto",
          backgroundColor: "#fff",
          "& .MuiInputBase-root": {
            backgroundColor: "#fff",
          },
          "& .MuiOutlinedInput-input": {
            backgroundColor: "#fff",
          },
          "& .disabled": {
            cursor: "not-allowed",
          },
        }}
        inputProps={{
          inputMode: type === "number" ? "numeric" : "text",
          maxLength: maxLength,
          style: {
            textTransform: allowCapitalization ? "capitalize" : "none",
            backgroundColor: "#fff",
            ...inputPropsStyle,
          },
        }}
        InputProps={{ startAdornment, endAdornment }}
        {...props}
      />
      {error && (
        <FormHelperText sx={{ color: "#d32f2f" }}>
          {errorMessage !== errorMessage ? t(errorMessage) : errorMessage}
        </FormHelperText>
      )}
      {countRequired && !error && isFocused && (
        <Stack direction={"row"} justifyContent="space-between">
          <FormHelperText sx={{ color: "#6c757d" }}>
            Please keep your input within {maxLength} characters
          </FormHelperText>
          <FormHelperText sx={{ color: "#6c757d" }}>
            {props.value ? props.value.length : 0}/{maxLength}
          </FormHelperText>
        </Stack>
      )}
    </FormControl>
  );
};
export default TextFieldComponent;
